<template>
  <div id="app" ref="elApp">

    <vue-headful :title="this.$PRJ_FULLNAME" />
    <fish-layout ref="elLayout">
      <div slot="content">
        <router-view />
      </div>
    </fish-layout>
  </div>
</template>
<script>
export default {
};
</script>
<style>
html,
body {
  height: 100%;
  font-size: 12px !important;
}

.fish.card>.content {
  flex: none;
  padding: unset !important;
}

.p10 {
  padding-left: 10px;
}

#app {
  font-family: SFProText;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: block;
  overflow: auto;
  height: 100%;
  margin-bottom: -40px;
}

@import "./assets/css/font-awesome.css";
@import "./assets/css/css.css?family=Lato:400,700,400italic,700italic&subset=latin";
</style>
